import React, { Component } from 'react';
import {
    Modal, Form, Input, DatePicker, InputNumber, Button, Select, Icon, Radio,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

const FormItem = Form.Item;
const { Option } = Select;

const { MonthPicker } = DatePicker;

class AddMedInfoModal extends Component {
    handleExpiryDisable = (current) => {
        const { expiryDate } = this.props;
        // console.log(expiryDate);
        return current && current < moment(expiryDate).add(1, 'month');
    }

    getTotalCount = () => {
        const { form } = this.props;
        const { getFieldValue } = form;

        if (getFieldValue('num_strips') == null || getFieldValue('per_strip') == null) {
            return 0;
        }
        return Number(getFieldValue('num_strips')) * Number(getFieldValue('per_strip'));
    }

    render() {
        const {
            visible, onCancel, data, form, partnersList, onCreate,
        } = this.props;

        const {
            name, batch_number, expiry_date, num_pills, num_strips, partner_location_id, per_strip,
        } = data;

        const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 15 },
            },
        };

        const addPills = (
            <Icon
                type="plus"
                onClick={() => {
                    setFieldsValue({ num_pills: Number(getFieldValue('num_pills')) + 1 });
                }}
            />
        );
        const removePills = (
            <Icon
                type="minus"
                onClick={() => {
                    setFieldsValue({ num_pills: Number(getFieldValue('num_pills')) - 1 });
                }}
            />
        );

        // console.log(partnersList);

        const partnersOption = partnersList.map(p => <Option key={p.id} value={p.id}>{p.name}</Option>);

        const { expiryDate } = this.props;
        console.log(expiryDate);

        return (
            <Modal
                visible={visible}
                title="Inventorize medicine"
                style={{ textAlign: 'center', top: 90 }}
                width="50%"
                onCancel={onCancel}
                onOk={onCreate}
                footer={[
                    <Button key="cancel" onClick={onCancel}>Return</Button>,
                    <Button key="submit" type="primary" onClick={onCreate}>
                        Submit
                    </Button>,
                ]}
            >
                <Form>
                    <FormItem
                        {...formItemLayout}
                        label="Name"
                    >
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: 'Name' }],
                            initialValue: name,
                        })(
                            <Input disabled />,
                        )}
                    </FormItem>

                    <FormItem>
                        {getFieldDecorator('batch_available', {
                            initialValue: num_pills == null ? 'true' : batch_number == null ? 'false' : 'true',
                        })(
                            <Radio.Group buttonStyle="solid" onChange={this.expChange} style={{ marginLeft: '10%' }}>
                                <Radio.Button value="true">
                                    Available
                                </Radio.Button>
                                <Radio.Button value="false">
                                    Not Available
                                </Radio.Button>
                            </Radio.Group>,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Batch #"
                    >
                        {getFieldDecorator('batch_number', {
                            rules: [{ required: getFieldValue('batch_available') === 'true', message: 'Either fill or select an option!' }],
                            initialValue: batch_number == null ? '' : batch_number,
                        })(
                            <Input disabled={getFieldValue('batch_available') === 'false'} />,
                        )}
                    </FormItem>

                    <FormItem>
                        {getFieldDecorator('exp_available', {
                            initialValue: num_pills == null ? 'true' : expiry_date == null || expiry_date === 'Invalid date' ? 'false' : 'true',
                        })(
                            <Radio.Group buttonStyle="solid" onChange={this.expChange} style={{ marginLeft: '10%' }}>
                                <Radio.Button value="true">
                                    Available
                                </Radio.Button>
                                <Radio.Button value="false">
                                    Not Available
                                </Radio.Button>
                            </Radio.Group>,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Expiry"
                    >
                        {getFieldDecorator('expiry_date', {
                            rules: [{ required: getFieldValue('exp_available') === 'true', message: 'Either fill or select an option!' }],
                            initialValue: expiry_date == null || expiry_date === 'Invalid date'
                                ? '' : moment(expiry_date),
                        })(
                            <MonthPicker
                                disabled={getFieldValue('exp_available') === 'false'}
                                disabledDate={this.handleExpiryDisable}
                                style={{ width: '100%' }}
                            />,
                        )}
                    </FormItem>

                    {/* <FormItem
                        {...formItemLayout}
                        label="Expiry"
                    >
                        {getFieldDecorator('expiry_date', {
                            rules: [
                                {
                                    required: getFieldValue('exp_available') === 'true',
                                    message: 'Either fill or select an option!',
                                },
                            ],
                            initialValue: expiry_date == null || expiry_date === 'Invalid date'
                                ? ''
                                : moment(expiry_date),
                        })(
                            <MonthPicker
                                disabled={getFieldValue('exp_available') === 'false'}
                                disabledDate={(current) => {
                                    const currentMonth = moment().startOf('month'); // Start of the current month
                                    const oneMonthFromNow = moment().add(1, 'month').startOf('month'); // Start of the next month
                                    return current && (current > currentMonth || current > oneMonthFromNow);
                                }}
                                style={{ width: '100%' }}
                            />
                        )}
                    </FormItem> */}

                    <FormItem
                        {...formItemLayout}
                        label="No. of Strip"
                    >
                        {getFieldDecorator('num_strips', {
                            // rules: [{ required: true, message: 'First Name of the Patient!' }],
                            initialValue: num_strips == null ? '' : num_strips,
                        })(
                            <InputNumber min={0} style={{ width: '100%' }} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Per Strip"
                    >
                        {getFieldDecorator('per_strip', {
                            // rules: [{ required: true, message: 'First Name of the Patient!' }],
                            initialValue: per_strip == null ? '' : per_strip,
                        })(
                            <InputNumber min={0} style={{ width: '100%' }} />,
                        )}
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                        label="Source"
                    >
                        {getFieldDecorator('partner_location_id', {
                            rules: [{ required: true, message: 'Location?' }],
                            initialValue: partner_location_id == null ? null : partner_location_id,
                        })(
                            <Select
                                style={{ width: '100%' }}
                                showSearch
                                placeholder="Select a partner"
                                optionFilterProp="children"
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                {partnersOption}
                            </Select>,
                        )}
                    </FormItem>

                    <FormItem>
                        {getFieldDecorator('num_pills', {
                            rules: [{ required: true, message: 'Total no of pills?' }],
                            initialValue: num_pills == null ? this.getTotalCount() : num_pills,
                        })(
                            <Input min={0} style={{ width: '30%', textAlign: 'center' }} addonBefore={removePills} addonAfter={addPills} />,
                        )}
                    </FormItem>

                </Form>
            </Modal>
        );
    }
}

const WrappedModal = Form.create()(AddMedInfoModal);

const mapStateToProps = state => ({
    expiryDate: state.InventoryState.expiry_date,
});

export default connect(mapStateToProps, null)(WrappedModal);



// WEBPACK FOOTER //
// ./src/component/Inventory/AddMedInfoModal.js